import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedDateTime, FormattedMessage, FormattedReactMessage } from '../../../components/I18n';
import { useTrackAwardProgress } from '../../userProgress';
import { useMostRecentExamAttempt } from '../../exams';
import ExamFinishedScreenLayout from './ExamFinishedScreenLayout';
import RetakeExamButton from './RetakeExamButton';
import { useFullTrack } from '../../tracks';

const ExamCertificationExpiredScreen = ({
  trackId
}) => {
  const {
    track,
    trackLoading,
    trackError
  } = useFullTrack(trackId);
  const {
    award,
    allProgressLoading,
    allProgressError
  } = useTrackAwardProgress(Number(trackId));
  const {
    mostRecentExamAttempt,
    mostRecentExamAttemptLoading,
    mostRecentExamAttemptError
  } = useMostRecentExamAttempt(Number(trackId));
  return /*#__PURE__*/_jsx(ExamFinishedScreenLayout, {
    callToAction: /*#__PURE__*/_jsx(RetakeExamButton, {
      trackId: trackId,
      use: "primary"
    }),
    error: trackError || allProgressError || mostRecentExamAttemptError,
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.isExpiredHeader"
    }),
    illustration: "announcement",
    loading: trackLoading || allProgressLoading || mostRecentExamAttemptLoading,
    prompt: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.yourPreviousScoreWas",
      options: {
        correctQuestionCount: mostRecentExamAttempt && mostRecentExamAttempt.score,
        totalQuestionCount: track && track.exam.length
      }
    }),
    subheading: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.exams.finished.isExpired",
      options: {
        expiryDate: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "ll",
          value: award.expiresAt
        })
      }
    }),
    trackId: trackId
  });
};

export default ExamCertificationExpiredScreen;